import React, { Component } from "react";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ToggleButtonRow from "./ToggleButtonRow";

import { Translate } from "react-redux-i18n";

import { momentModule } from "../../Utils";

import "../../../../styles/components/utils/components/availabilityPicker/AvailabilityPicker.scss";

const { moment } = momentModule;
const buttonArr = [...Array(24).keys()].map((el, i) => ({
  name: i.toString() + "h",
  checked: false,
}));

class AvailabilityPicker extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      sunday: {
        checked: false,
        label: "availabilityPicker_sunday",
        buttons: Array.from(buttonArr),
      },
      monday: {
        checked: false,
        label: "availabilityPicker_monday",
        buttons: Array.from(buttonArr),
      },
      tuesday: {
        checked: false,
        label: "availabilityPicker_tuesday",
        buttons: Array.from(buttonArr),
      },
      wednesday: {
        checked: false,
        label: "availabilityPicker_wednesday",
        buttons: Array.from(buttonArr),
      },
      thursday: {
        checked: false,
        label: "availabilityPicker_thursday",
        buttons: Array.from(buttonArr),
      },
      friday: {
        checked: false,
        label: "availabilityPicker_friday",
        buttons: Array.from(buttonArr),
      },
      saturday: {
        checked: false,
        label: "availabilityPicker_saturday",
        buttons: Array.from(buttonArr),
      },
      firstDraggedBtn: null,
    };

    this.handleOnTopBtnChange = this.handleOnTopBtnChange.bind(this);
    this.handleOnMouseDown = this.handleOnMouseDown.bind(this);
    this.handleOnMouseMove = this.handleOnMouseMove.bind(this);
    this.handleOnMouseUp = this.handleOnMouseUp.bind(this);
    this.updateTopBtn = this.updateTopBtn.bind(this);
    this.findBtnByName = this.findBtnByName.bind(this);
    this.shouldToggle = this.shouldToggle.bind(this);
  }

  componentDidMount() {
    this._mounted = true;

    // Load custom availability
    if (this.props.availability) {
      ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].map(
        weekDay => {
          if (this.props.availability[weekDay]?.ranges?.length > 0)
            this.props.availability[weekDay]?.ranges?.forEach(range => {
              const { startTime, endTime } = range;
              const startMoment = moment.utc(startTime, "HH:mm");
              const endMoment = moment.utc(endTime, "HH:mm");

              // loop over if endMoment is before or same as startMoment
              if (endMoment.isSameOrBefore(startMoment)) endMoment.add(1, "day");
              const durationInHours = moment.duration(endMoment.diff(startMoment)).asHours();

              for (let hour = 0; hour < durationInHours; hour++) {
                this.safeSetState(
                  prevState => ({
                    [weekDay]: {
                      ...prevState[weekDay],
                      buttons: [
                        ...prevState[weekDay].buttons.slice(0, startMoment.hour() + hour),
                        {
                          ...prevState[weekDay].buttons[startMoment.hour() + hour],
                          checked: true,
                        },
                        ...prevState[weekDay].buttons.slice(startMoment.hour() + hour + 1),
                      ],
                    },
                  }),
                  () => this.updateTopBtn(weekDay)
                );
              }
            });
          else if (this.props.availability[weekDay]?.availabilityDay === "allDay")
            this.safeSetState(prevState => ({
              [weekDay]: {
                ...prevState[weekDay],
                checked: true,
                buttons: prevState[weekDay].buttons.map(btn => ({ ...btn, checked: true })),
              },
            }));
        }
      );
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleOnTopBtnChange(e, weekDay) {
    this.safeSetState(
      prevState => ({
        [weekDay]: {
          ...prevState[weekDay],
          checked: !prevState[weekDay].checked,
          buttons: prevState[weekDay].buttons.map(btn => ({
            ...btn,
            checked: !prevState[weekDay].checked,
          })),
        },
      }),
      () => {
        const { firstDraggedBtn, ...weekDays } = this.state;
        this.props.onRangeChange(weekDays);
      }
    );
  }

  handleOnMouseDown(e, weekDay) {
    const { btn, idx } = this.findBtnByName(weekDay, e.target.firstChild.name);
    if (this.shouldToggle(weekDay, btn, idx))
      this.safeSetState(
        prevState => ({
          [weekDay]: {
            ...prevState[weekDay],
            buttons: [
              ...prevState[weekDay].buttons.slice(0, idx),
              Object.assign({}, btn, { checked: !btn.checked }),
              ...prevState[weekDay].buttons.slice(idx + 1),
            ],
          },
          firstDraggedBtn: { ...btn, weekDay },
        }),
        () => this.updateTopBtn(weekDay)
      );
  }

  handleOnMouseMove(e, weekDay) {
    if (
      e.buttons === 1 &&
      this.state.firstDraggedBtn?.name !== e.target.firstChild.name &&
      weekDay === this.state.firstDraggedBtn?.weekDay
    ) {
      const { btn, idx } = this.findBtnByName(weekDay, e.target.firstChild.name);
      if (this.shouldToggle(weekDay, btn, idx))
        this.safeSetState(
          prevState => ({
            [weekDay]: {
              ...prevState[weekDay],
              buttons: [
                ...prevState[weekDay].buttons.slice(0, idx),
                Object.assign({}, btn, { checked: !this.state.firstDraggedBtn.checked }),
                ...prevState[weekDay].buttons.slice(idx + 1),
              ],
            },
          }),
          () => this.updateTopBtn(weekDay)
        );
    }
  }

  handleOnMouseUp(e) {
    this.safeSetState(
      {
        firstDraggedBtn: null,
      },
      () => {
        const { firstDraggedBtn, ...weekDays } = this.state;
        this.props.onRangeChange(weekDays);
      }
    );
  }

  updateTopBtn(weekDay) {
    const anyBtnChecked = this.state[weekDay].buttons.some(btn => btn.checked);

    this.safeSetState(prevState => ({
      [weekDay]: {
        ...prevState[weekDay],
        checked: anyBtnChecked,
      },
    }));
  }

  findBtnByName(weekDay, name) {
    const idx = parseInt(name.slice(0, -1));
    return { btn: this.state[weekDay].buttons[idx], idx };
  }

  shouldToggle(weekDay, btn, idx) {
    const buttons = this.state[weekDay].buttons;
    const checked = buttons.filter(btn => btn.checked);

    // if first or last index, no previous or last button to compare to, respectively
    // just return true if no other buttons are checked
    if (checked.length === 0 && (idx === 0 || idx === this.state[weekDay].buttons.length - 1))
      return true;

    const prevButton = buttons[idx - 1 < 0 ? buttons.length - 1 : idx - 1];
    const nextButton = buttons[idx + 1 > buttons.length - 1 ? 0 : idx + 1];

    return (
      checked.length === 0 ||
      checked.length === buttons.length ||
      (checked.length === 1 && btn.checked) ||
      (prevButton.checked && !nextButton.checked) ||
      (!prevButton.checked && nextButton.checked) ||
      (prevButton.checked && nextButton.checked && !btn.checked)
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div id="availabilityPicker">
        <div className="i-paragraph">
          <Translate value="availabilityPicker_selectAvailableDays" />
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip id="availability-picker-info" className="evio-tooltip mini">
                <Translate value="availabilityPicker_clickNDrag" />
              </Tooltip>
            }
          >
            <div className="i-tooltip">i</div>
          </OverlayTrigger>
        </div>
        <div className="picker">
          {["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].map(
            weekDay => {
              const weekDayObj = this.state[weekDay];
              return (
                <ToggleButtonRow
                  key={weekDay}
                  label="h"
                  topBtn={{
                    name: weekDay,
                    ...weekDayObj,
                  }}
                  onTopBtnChange={e => this.handleOnTopBtnChange(e, weekDay)}
                  onMouseMove={e => this.handleOnMouseMove(e, weekDay)}
                  onMouseDown={e => this.handleOnMouseDown(e, weekDay)}
                  onMouseUp={this.handleOnMouseUp}
                />
              );
            }
          )}
        </div>
      </div>
    );
  }
}

export default AvailabilityPicker;
